import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
    mea_state:false,  // 测量组件开启状态
};
const store = new Vuex.Store({
    state
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js